/**
 * Browser-local memory for the Enhance flow: whether a user has already read
 * the first-time disclosure, kept per user so a shared machine still shows
 * it to the next person. A revert to the original is not kept here: the
 * backend saves it on the accepted variant, for everyone.
 *
 * Every read and write is wrapped in try/catch: localStorage can be missing,
 * full, or blocked (private windows, embedded previews), and none of that
 * may break the grid.
 */
import { perUserDismissedFlag } from '@/utils/global/perUserDismissedFlag'

const disclosureDismissed = perUserDismissedFlag(
  'mdl.caseImages.enhanceDisclosureDismissed.',
  '1',
)

/** True when this user already dismissed the "Enhance images with AI" disclosure. */
export const readEnhanceDisclosureDismissed = disclosureDismissed.isDismissed

/** Remember that this user dismissed the disclosure so later runs skip it. */
export const writeEnhanceDisclosureDismissed = disclosureDismissed.remember
